import styled from 'styled-components';

/* Preenche todo o véu do Loading. Sem fundo próprio, sem borda: a opacidade
   vem do véu e a malha entra só como detalhe por cima dele. */
export const GridBox = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
`;

export const Canvas = styled.canvas`
  display: block;
  width: 100%;
  height: 100%;
`;
